var _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.858 112.406C511.858 103.497 501.086 99.0356 494.787 105.335L94.9289 505.193C91.0237 509.098 91.0237 515.43 94.9289 519.335L494.787 919.193C501.086 925.493 511.858 921.031 511.858 912.122V112.406Z",
    fill: "#FFC700"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 357,
    y: 350,
    width: 522,
    height: 323,
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M511.858 112.406C511.858 103.497 501.086 99.0356 494.787 105.335L94.9289 505.193C91.0237 509.098 91.0237 515.43 94.9289 519.335L494.787 919.193C501.086 925.493 511.858 921.031 511.858 912.122V112.406Z",
    fill: "#FFC700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M357 350H879V673H357V350Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.a9e1d42ff3d4cd6404a9659dc19cb11a.svg";
export { ForwardRef as ReactComponent };